import { Map } from 'react-leaflet';
import { LatLng, LatLngBounds, LatLngLiteral, LatLngTuple } from 'leaflet';

export const fitMap = ({
  latLng,
  map,
}: {
  map: Map | null;
  latLng: LatLngLiteral[];
}) => {
  if (map) {
    if (latLng.length > 1) {
      const bounds = new LatLngBounds(latLng.map(({ lng, lat }) => [lat, lng]));
      map.leafletElement.fitBounds(bounds);
    } else if (latLng.length === 1) {
      map.leafletElement.setView([latLng[0].lat, latLng[0].lng], 16);
    }
  }
};

export const latLngToTuple = ({ lat, lng }: LatLng): LatLngTuple => [lat, lng];

export const latLngsArrayToTuplesArray = (array: LatLng[]): LatLngTuple[] =>
  array.map((latLng) => latLngToTuple(latLng));

/*
 * input в формате "POINT(Float, Float)"
 * */
export const parsePoint = (input: string): null | [number, number] => {
  const parsed = input.match(/\d+(\.\d+)?/g);
  if (!parsed) return null;
  return parsed.map((value) => parseFloat(value)).reverse() as [number, number];
};

export const formatCoord = (coord: number, coordsFractionDigits = 5): string => {
  const [integer, fractional] = coord.toString().split('.');
  if (!fractional || fractional.trim() === '') {
    return integer;
  }
  return fractional.length > coordsFractionDigits
         ? coord.toFixed(coordsFractionDigits)
         : coord.toString();
};
